<template>
  <!--
    <div class="module-border-wrap">
  -->
  <div>
    <div class="module">
      {{ filterText }} - {{ filterStat }}
      <a @click.prevent="$emit('delete')"
        ><span v-if="true" class="fas fa-times remove-tag-icon"></span
      ></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "FiltersBar",
  props: {
    filterText: {
      type: String,
      required: true
    },
    filterStat: {
      type: String,
      required: false
    },
    filterKey: {
      type: String,
      required: true
    },
    arrLength: {
      type: Number,
      required: true
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
.module-border-wrap {
  width: max-content;
  margin-left: 2px;
  margin-right: 2px;
  position: relative;
  background: linear-gradient(to right, #6a1b9a, #1565c0);
  padding: 2px;
  border-radius: 2.5px;
}

.module {
  background: white;
  padding: 3px;
  height: 24px;
  font-weight: 700;
  border-radius: 2px;
}

.module:hover {
  background: #e0e0e0;
}

.remove-tag-icon {
  cursor: pointer;
  margin-left: 5px;
  color: red;
}
</style>
